import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import forms from './forms'

const namespaced = true

const defaultMeta =  {
  paginate: true,
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'order',
  per_page: null,
  search: null,
  total: null
}

const _defaultView = 'all'
const _archivedView = 'archived'
const _clientView = 'client'

const state = {
  current: null,
  _defaultView,
  _archivedView,
  _clientView,
  complete: {
    index: {},
    ids: []
  },
  views: {
    [_defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        showHidden: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_archivedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: true,
        showHidden: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [_clientView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        active: true,
        showHidden: false,
        archived: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
  modules: {
    forms
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/components/index.js